import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ProductDTO } from 'src/app/shared/models/dtos/responses/product-dto/product-dto';

@Component({
  selector: 'app-product-overview',
  templateUrl: './product-overview.component.html',
  styleUrls: ['./product-overview.component.scss'],
})

/**
 * Product Overview and option for edit product.
 */
export class ProductOverviewComponent {
  @Input() data!: ProductDTO;
  @Output() editProduct: EventEmitter<void> = new EventEmitter<void>();
  participatingProductLabel = 'participating-product';
  printerHeadersLabel = 'printer-headers';
  printerFamilyLabel = 'printer-family';

  /**
   * Emits an event to trigger the product edit action.
   */
  goToProductEdit() {
    this.editProduct.emit();
  }

  /**
   * Handles image access error on s3
   */
  handleImageError() {
    this.data.image = '';
  }
}
